import { Stack } from "@mui/material";
import Typography from "common/components/Typography";
import React from "react";
import { DividerLeft, DividerRight } from "assets/icons";

type PageHeaderProps = {
  label: string;
};

const PageHeader = (props: PageHeaderProps) => {
  const { label } = props;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{ svg: { width: "15rem" } }}
    >
      <DividerRight />
      <Typography>{label}</Typography>
      <DividerLeft />
    </Stack>
  );
};

export default PageHeader;
